import { setCookie, removeCookie } from '@/services/cookie'
import {
  eventType,
  constantStrings,
  cookieConstant
} from '@/services/constants'
import {
  refreshStorageAndClearChats,
  isTypeBOT,
  lazyLoadLiveAgent,
  isUserLoggedIn,
  getSupportIconWidthAndHeight
} from '@/services/utils'
import session from '@/services/session'
import { emitEventToParentWindow } from '@/services/utils'
import {
  login,
  logout,
  getAgentDeskConnectionStatus
} from '@/services/authentication'
import { GlobalVars } from '@/services/globals'
import mqttClient from '@/services/aws-iot/mqtt'
import { oauthLogin, oauthLogout } from '@/services/authDetails'
import { AUTH_CONSTANTS } from '@/constants/authentication'
import AppLog from '@/services/errors/app-logs'
import Storage from '@/services/storageLib'

export default {
  updateTokenInWidget({ commit }, data) {
    setCookie(cookieConstant.AUTH.AUTH_TOKEN, data)
    commit('UPDATE_TOKEN_IN_WIDGET', data)
  },
  async setUserLoggedIn({ commit, dispatch, rootState }, jwt) {
    dispatch('updateTokenInWidget', jwt)
    if (rootState.widgetConfig.isAuthenticationEnabled) {
      const user = await login(jwt)
      const userLoggedIn = user.data.statusCode === 200
      const authenticatedConversationId = user.data?.authenticatedConversationId
      if (userLoggedIn) {
        const externalId = user.data?.externalId
        Storage.setLocalStorageData(
          AUTH_CONSTANTS.USER_DETAILS,
          user.data,
          false
        )
        commit('UPDATE_EXTERNAL_ID', externalId)
        commit(
          'UPDATE_AUTHENTICATED_CONVERSATION_ID',
          authenticatedConversationId
        )
        refreshStorageAndClearChats(userLoggedIn)
        dispatch('setEndChatTimer', { delay: 0, isGuest: false })

        setCookie(cookieConstant.AUTH.USER_LOGGED_IN, userLoggedIn)

        session.createAuthenticatedConversationID(authenticatedConversationId)
        if (rootState.isWindowMaximized || rootState.isChatWidgetFullScreen) {
          dispatch('toggleChatWindowStatus', false)
          emitEventToParentWindow(
            eventType.UPDATE_PARENT_WINDOW_STYLE,
            getSupportIconWidthAndHeight()
          )
        }
        commit('UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG', true)
        dispatch('reinitialiseLiveAgent')
      }
    }
  },
  async logoutWidget({ commit, dispatch }) {
    new AppLog({
      name: 'NET-57075 logoutWidget authentcation.js - entry',
      message: 'User logout widget called',
      logLevel: 'info',
      service: 'Action'
    })
    dispatch('toggleChatWindowStatus', false)
    emitEventToParentWindow(
      eventType.UPDATE_PARENT_WINDOW_STYLE,
      getSupportIconWidthAndHeight()
    )
    if (!isTypeBOT()) {
      new AppLog({
        name: 'NET-57075 logoutWidget authentcation.js - not bot',
        message: 'Not BOT control type - ending live agent chat',
        logLevel: 'info',
        service: 'Action'
      })
      await GlobalVars.$liveAgent.endChatWithLiveAgent()
      await GlobalVars.$liveAgent.sendBackToBotUtterance() //TODO: refactor the endChatWithLiveAgent function to call back to bot without custom attributes
    }
    await logout()
    refreshStorageAndClearChats(true)
    removeCookie(cookieConstant.AUTH.AUTH_TOKEN)
    commit('UPDATE_TOKEN_IN_WIDGET', '')
    removeCookie(cookieConstant.AUTH.USER_LOGGED_IN)
    dispatch('updateQuickReplyOptions', [])
    dispatch('updateActionableNBAOptions', [])
    dispatch('updateNonActionableNBAOptions', [])
    dispatch('updateTypingIndicatorStatus', false)
    session.endConversation()
    mqttClient.unsubscribe()
    commit('UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG', true)
  },
  async reinitialiseLiveAgent({ dispatch, rootState }) {
    const userLoggedIn = isUserLoggedIn()
    const agentDeskConnectionStatus =
      userLoggedIn && (await getAgentDeskConnectionStatus())
    if (userLoggedIn) {
      dispatch(
        'updateAgentDeskConnectionStatus',
        agentDeskConnectionStatus?.data['agentDeskConnectionStatus']
      )
      agentDeskConnectionStatus?.data['agentDeskConnectionStatus'] ===
        'connected' && dispatch('updateControlType', constantStrings.AGENT)
    }

    if (!isTypeBOT(rootState.controlType)) {
      lazyLoadLiveAgent()
    }
  },
  async setOauthUserLoggedIn(
    { commit, dispatch },
    authenticatedConversationId
  ) {
    if (authenticatedConversationId) {
      commit(
        'UPDATE_AUTHENTICATED_CONVERSATION_ID',
        authenticatedConversationId
      )
      refreshStorageAndClearChats(true)
      dispatch('setEndChatTimer', { delay: 0, isGuest: false })

      setCookie(cookieConstant.OAUTH.LOGGED_IN, 'true')
      setCookie(cookieConstant.SESSION.CONVERSATION_INITIATED, 'true')
      // setCookie(cookieConstant.AUTH.USER_LOGGED_IN, true)

      session.createAuthenticatedConversationID(authenticatedConversationId)
      commit('UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG', true)
      dispatch('fetchHistory')
      // dispatch('reinitialiseLiveAgent')
    }
  },
  async setOauthlogoutWidget({ commit, dispatch }) {
    new AppLog({
      name: 'NET-57075 setOauthlogoutWidget authentcation.js - entry',
      message: 'OAuth logout widget called',
      logLevel: 'info',
      service: 'Action'
    })
    dispatch('toggleChatWindowStatus', false)
    emitEventToParentWindow(
      eventType.UPDATE_PARENT_WINDOW_STYLE,
      getSupportIconWidthAndHeight()
    )
    if (!isTypeBOT()) {
      new AppLog({
        name: 'NET-57075 setOauthlogoutWidget authentcation.js - not bot',
        message: 'Not BOT control type - ending live agent chat',
        logLevel: 'info',
        service: 'Action'
      })
      await GlobalVars.$liveAgent.endChatWithLiveAgent()
      await GlobalVars.$liveAgent.sendBackToBotUtterance() //TODO: refactor the endChatWithLiveAgent function to call back to bot without custom attributes
    }
    refreshStorageAndClearChats(true)
    removeCookie(cookieConstant.SESSION.CONVERSATION_INITIATED)
    Storage.removeLocalStorageData(AUTH_CONSTANTS.USER_DETAILS, false)
    Storage.removeLocalStorageData(AUTH_CONSTANTS.ISAUTH, false)
    commit('UPDATE_TOKEN_IN_WIDGET', '')
    removeCookie(cookieConstant.OAUTH.LOGGED_IN)
    dispatch('updateQuickReplyOptions', [])
    dispatch('updateActionableNBAOptions', [])
    dispatch('updateNonActionableNBAOptions', [])
    dispatch('updateTypingIndicatorStatus', false)
    session.endConversation()
    mqttClient.unsubscribe()
    commit('UPDATE_CALLOUT_BUBBLE_ENABLED_FLAG', true)
  },
  async loginUsingOauth(_, { messageInfo }) {
    const { authorization_code, access_token } = messageInfo
    return await oauthLogin(authorization_code, access_token)
  },
  async logoutUsingOauth({ dispatch }) {
    await oauthLogout()
    dispatch('setOauthlogoutWidget')
  }
}
